// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.stacked-bar-chart{zoom:75%}}.stacked-bar-chart .title{display:block;font-size:12px;text-align:center;text-transform:uppercase;width:100%}.stacked-bar-chart .custom-tooltip{background-color:#fff;padding:8px}.stacked-bar-chart .custom-tooltip .date{color:#666;font-weight:400;margin-bottom:4px}.stacked-bar-chart .custom-tooltip .data-key-item{padding:4px 4px 4px 0}", ""]);
// Exports
module.exports = exports;
